import React, { Component } from "react";
import isEqual from "react-fast-compare";

import './imageMapper.css'
import expandIcon from '../../assets/expand@2x.png'


export default class ImageMapper extends Component {
    constructor(props) {
        super(props);
        [
            'initCanvases'
        ].forEach(f => (this[f] = this[f].bind(this)));
        let absPos = { position: 'absolute', top: 0, left: 0 };
        let canvas = { ...absPos, pointerEvents: 'none' };
        this.styles = {
            container: { position: 'relative' },
            hoverCanvas: { ...canvas, zIndex: 4 },
            clickCanvas: { ...canvas, zIndex: 3 },
            prefillCanvas: { ...canvas, zIndex: 2 },
            img: { ...absPos, userSelect: 'none' },
            map: (props.onClick && { cursor: 'pointer' }) || undefined
        };
        this.state = { imgWidth: this.props.imgWidth }
        this.prevImgRef = null;
        this.imgRef = React.createRef();
        if (this.props.imgRef) {
            this.imgRef = this.props.imgRef;
        }
        if (this.props.onExtendedAreasCreated) {
            this.props.onExtendedAreasCreated(this.getExtendedAreas());
        }
    }

    getPngDimensions(imgUrl) {
        let base64 = imgUrl.split(',')[1]
        const header = atob(base64.slice(0, 50)).slice(16, 24)
        const uint8 = Uint8Array.from(header, c => c.charCodeAt(0))
        const dataView = new DataView(uint8.buffer)
        const width = dataView.getInt32(0)
        return width
    }


    componentDidMount() {
        this.prevImgRef = this.imgRef.current;
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps, this.props)) {
            this.setState({
                currentlyHoveredArea: undefined,
                imgWidth: this.props.imgWidth
            });
            if (this.imgRef.current !== this.prevImgRef) {
                this.imgRef = this.props.imgRef || React.createRef();
            }
            this.prevImgRef = this.imgRef.current;
        }
        this.initCanvases();
    }

    initCanvases() {
        if (this.imgRef.current) {
            if (this.props.width) this.imgRef.current.width = this.props.width;

            if (this.props.height) this.imgRef.current.height = this.props.height;

            this.prefillSvg.setAttribute('viewBox', `0 0 ${this.props.width || this.imgRef.current.clientWidth} ${this.props.height || this.imgRef.current.clientHeight}`);
            this.hoverSvg.setAttribute('viewBox', `0 0 ${this.props.width || this.imgRef.current.clientWidth} ${this.props.height || this.imgRef.current.clientHeight}`);
            this.clickSvg.setAttribute('viewBox', `0 0 ${this.props.width || this.imgRef.current.clientWidth} ${this.props.height || this.imgRef.current.clientHeight}`);

            this.container.style.width =
                (this.props.width || this.imgRef.current.clientWidth) + 'px';
            this.container.style.height =
                (this.props.height || this.imgRef.current.clientHeight) + 'px';
        }

        if (this.props.onLoad) this.props.onLoad();
    }

    hoverOn(area, index, event) {
        if (this.props.onMouseEnter) this.props.onMouseEnter(area, index, event);
        this.setState({
            currentlyHoveredArea: area,
        });
    }

    hoverOff(area, index, event) {
        if (this.props.onMouseLeave) this.props.onMouseLeave(area, index, event);

        this.setState({
            currentlyHoveredArea: undefined,
            showMagnifier: false
        });
    }

    click(area, index, event) {
        if (this.props.onClick) {
            event.preventDefault();
            this.props.onClick(area, index, event);
            if (area.type === "result_display_room") {
                this.setState({
                    currentlyHoveredArea: undefined,
                });
            }
        }
    }

    imageClick(event) {
        if (this.props.onImageClick) {
            event.preventDefault();
            this.props.onImageClick(event);
            this.setState({
                currentlyHoveredArea: undefined,
            });
        }
    }

    mouseMove(area, index, event) {
        if (this.props.onMouseMove) {
            this.props.onMouseMove(area, index, event);
        }
    }

    mouseDown(area, index, event) {
        if (this.props.onMouseDown) {
            this.props.onMouseDown(area, index, event);
        }
    }

    mouseUp(area, index, event) {
        if (this.props.onMouseUp) {
            this.props.onMouseUp(area, index, event);
        }
    }

    imageMouseMove = (event) => {
        const elem = event.currentTarget;
        const { top, left } = elem.getBoundingClientRect();
        // calculate cursor position on the image
        const x = event.pageX - left - window.pageXOffset;
        const y = event.pageY - top - window.pageYOffset;
        this.setState({ x: x, y: y })
    }
    imageMouseEnter = (event) => {
        const elem = event.currentTarget;
        const { width, height } = elem.getBoundingClientRect();
        this.setState({
            imgWidthMagnify: width,
            imgHeightMagnify: height,
            showMagnifier: true
        });
    }

    imageMouseDown(area, index, event) {
        if (this.props.onImageMouseDown) {
            this.props.onImageMouseDown(area, index, event);
        }
    }

    imageMouseUp(area, index, event) {
        if (this.props.onImageMouseUp) {
            this.props.onImageMouseUp(area, index, event);
        }
    }

    scaleCoords(coords) {
        const { width } = this.props;
        const { imgWidth } = this.state;
        // calculate scale based on current 'width' and the original 'imgWidth'
        const scale = width && imgWidth && imgWidth > 0 ? width / imgWidth : 1;
        return coords.map(coord => coord * scale);
    }

    mapCoordsToSvgFormat(coords) {
        return coords.reduce(
            (a, v, i, s) => (i % 2 ? a : [...a, s.slice(i, i + 2)]),
            []
        ).join(' ');
    }

    computeCenter(area) {
        if (!area) return [0, 0];

        const scaledCoords = this.scaleCoords(area.coords);

        switch (area.shape) {
            case 'circle':
                return [scaledCoords[0], scaledCoords[1]];
            case 'poly':
            case 'rect':
            default: {
                // Calculate centroid
                const n = scaledCoords.length / 2;
                const { y, x } = scaledCoords.reduce(
                    ({ y, x }, val, idx) => {
                        return !(idx % 2) ? { y, x: x + val / n } : { y: y + val / n, x };
                    },
                    { y: 0, x: 0 }
                );
                return [x, y];
            }
        }
    }

    getExtendedAreas() {
        return this.props.map.areas.map((area) => {
            const scaledCoords = this.scaleCoords(area.coords);
            const center = this.computeCenter(area);
            return { ...area, scaledCoords, center };
        });
    }

    drawSampleMapping = (sample_areas) => {
        return sample_areas.map((area, index) => {
            if (!area.preFillColor) return null;
            const scaledCoords = this.scaleCoords(area.coords);
            const width = Math.abs(scaledCoords[2] - scaledCoords[0]);
            const height = Math.abs(scaledCoords[3] - scaledCoords[1]);
            const x = Math.min(scaledCoords[0], scaledCoords[2]);
            const y = Math.min(scaledCoords[1], scaledCoords[3]);
            
            // Skip invalid rectangles
            if (width <= 0 || height <= 0) {
                console.warn('Invalid rect dimensions:', {width, height, coords: scaledCoords, area: area.name});
                return null;
            }
            
            return (<rect
                key={area.name || area._id || `sample-${index}`}
                x={x}
                y={y}
                width={width}
                height={height}
                fill={area.preFillColor || 'transparent'}
                stroke={area.strokeColor || this.props.strokeColor}
                strokeWidth={area.lineWidth || this.props.lineWidth}
                rx="1px"
            />
            )
        }).filter(Boolean); // Remove null elements
    }

    getMatchingSvgElementForShape(shape, coords, props, ishover, type, text, area) {
        const scaledCoords = this.scaleCoords(coords);
        let { width } = this.props;
        if(ishover){
            width = width + 700
        }
        const { imgWidth } = this.state;
        let top = (scaledCoords[1] > scaledCoords[3])? scaledCoords[3]: scaledCoords[1]
        let right = (scaledCoords[0] > scaledCoords[2])? scaledCoords[0]: scaledCoords[2]
        let ratio = width / imgWidth
        let roomAndPolyStyle = { font: "500 " + 10 * ratio + "px Montserrat", fill: "#243682" }
        let rectStyle = { font: "600 " + 13 * ratio + "px sans-serif", fill: "white" }
        let imageRadius = 12 * ratio
        let imgWidthHeigth = 12 * ratio
        let margin = 5 * ratio
        let x = right - imgWidthHeigth - margin - imageRadius / 2
        let y = top + imageRadius / 2 + margin
        
        // Calculate valid rect dimensions
        const rectWidth = Math.abs(scaledCoords[2] - scaledCoords[0]);
        const rectHeight = Math.abs(scaledCoords[3] - scaledCoords[1]);
        const rectX = Math.min(scaledCoords[0], scaledCoords[2]);
        const rectY = Math.min(scaledCoords[1], scaledCoords[3]);
        
        switch (shape) {
            case 'room':
                // Skip invalid rectangles
                if (rectWidth <= 0 || rectHeight <= 0) {
                    console.warn('Invalid room rect dimensions:', {rectWidth, rectHeight, coords: scaledCoords, area: area?.name});
                    return null;
                }
                
                let roomElements = [<rect
                    key={`room-rect-${area?.name || props.key || 'unknown'}`}
                    x={rectX}
                    y={rectY}
                    width={rectWidth}
                    height={rectHeight}
                    {...props}
                    fillOpacity={0.5}
                    strokeWidth={2}
                />
                ]
                if (!ishover || type !== 'result_tracking_room') {
                    const textX = rectX + rectWidth / 2;
                    const textY = rectY + rectHeight / 2;
                    if(area.name == "Unknown Room"){
                        roomElements.push(
                            <text
                            key={`room-text-${area?.name || 'unknown'}-${props.key || 'unknown'}`}
                            x={textX}
                            y={textY}
                            dominantBaseline="middle"
                            textAnchor="middle"
                            style={roomAndPolyStyle}
                            className = {text}
                        >
                        </text>
                        )
                    }
                    else{
                        roomElements.push(<text
                            key={`room-text-${area?.name || text || 'unknown'}-${props.key || 'unknown'}`}
                            x={textX}
                            y={textY}
                            dominantBaseline="middle"
                            textAnchor="middle"
                            style={roomAndPolyStyle}
                            className = {text}
                        >
                            {text}
                        </text>)
                    }
                    if(ishover){
                    document.getElementById("prefill-layer").getElementsByClassName(text)[0].style.fillOpacity= "0"
                    }
                    else if(document.getElementById("prefill-layer") && !ishover && document.getElementById("prefill-layer").getElementsByClassName(text)[0]){
                        document.getElementById("prefill-layer").getElementsByClassName(text)[0].style.fillOpacity = "1"
                    }
                }
                if (ishover && type === 'result_tracking_room') {
                    const textX2 = rectX + rectWidth / 2;
                    const textY2 = rectY + rectHeight / 2;
                    if(area.name == "Unknown Room"){
                        roomElements.push(
                            <text
                            key={`hover-text-unknown-${area?.name || props.key || 'unknown'}`}
                            x={textX2}
                            y={textY2}
                            dominantBaseline="middle"
                            textAnchor="middle"
                            style={roomAndPolyStyle}
                            className = {text}
                        >
                        </text>
                        )
                    }
                    else{
                        roomElements.push(<text
                            key={`hover-text-${area?.name || text || props.key || 'unknown'}`}
                            x={textX2}
                            y={textY2}
                            dominantBaseline="middle"
                            textAnchor="middle"
                            style={roomAndPolyStyle}
                            className = {text}
                        >
                            {text}
                        </text>)
                    }
                    if(ishover){
                        document.getElementById("prefill-layer").getElementsByClassName(text)[0].style.fillOpacity= "0"
                        }
                }

                if (ishover && type === "sample_floor_room") {
                    let sample_elements = this.drawSampleMapping(area.sample_areas)
                    roomElements.push(...sample_elements)
                    roomElements.push(
                        <circle
                            key={`circle-${area?.name || props.key || 'unknown'}`}
                            cx={right - imageRadius - margin}
                            cy={top + imageRadius + margin}
                            r={imageRadius}
                            fill="white"
                            strokeColor="white"
                        />
                    )
                    roomElements.push(
                        <image 
                            key={`expand-icon-${area?.name || props.key || 'unknown'}`}
                            href={expandIcon} 
                            x={x} 
                            y={y} 
                            height={imgWidthHeigth} 
                            width={imgWidthHeigth} 
                        />
                    )
                }
                if (ishover && type === "result_display_room") {
                    let sample_elements = this.drawSampleMapping(area.sample_areas)
                    roomElements.push(...sample_elements)
                }
                return (roomElements);
            case 'rect':
                const rectWidth2 = Math.abs(scaledCoords[2] - scaledCoords[0]);
                const rectHeight2 = Math.abs(scaledCoords[3] - scaledCoords[1]);
                const rectX2 = Math.min(scaledCoords[0], scaledCoords[2]);
                const rectY2 = Math.min(scaledCoords[1], scaledCoords[3]);
                
                // Skip invalid rectangles
                if (rectWidth2 <= 0 || rectHeight2 <= 0) {
                    console.warn('Invalid rect dimensions:', {rectWidth2, rectHeight2, coords: scaledCoords, area: area?.name});
                    return null;
                }
                
                if (type === "result_tracking") {
                    return (
                        [<rect
                            key={`rect-${area?.name || text || props.key || 'unknown'}`}
                            className={text}
                            x={rectX2}
                            y={rectY2}
                            width={rectWidth2}
                            height={rectHeight2}
                            {...props}
                            linewidth={1.5}
                            stroke="transparent"
                            rx={ratio * 2 + "px"}
                        />,
                        <text
                            key={`rect-text-${area?.name || text || props.key || 'unknown'}`}
                            x={rectX2 + rectWidth2 / 2}
                            y={rectY2 + rectHeight2 / 2}
                            dominantBaseline="middle"
                            textAnchor="middle"
                            style={rectStyle}
                        >
                            {text}
                        </text>
                        ])
                }

                return (
                    <rect
                        x={rectX2}
                        y={rectY2}
                        width={rectWidth2}
                        height={rectHeight2}
                        {...props}
                        rx={ratio * 2 + "px"}
                    />

                );
            case 'circle':
                return (
                    <circle
                        cx={scaledCoords[0]}
                        cy={scaledCoords[1]}
                        r={scaledCoords[2]}
                        {...props}
                    />
                );
            case 'line':
                return (
                    <line
                        x1={scaledCoords[0]}
                        y1={scaledCoords[1]}
                        x2={scaledCoords[2]}
                        y2={scaledCoords[3]}
                        {...props}
                        strokeDasharray="2,2"
                    />
                );
            case 'poly':
                let rect_coords = area.locationObject.rect_coordinates.split(",").map(Number)
                const scaledRectCoords = this.scaleCoords(rect_coords)
                top = (scaledRectCoords[1] > scaledRectCoords[3])? scaledRectCoords[3]: scaledRectCoords[1]
                right = (scaledRectCoords[0] > scaledRectCoords[2])? scaledRectCoords[0]: scaledRectCoords[2]
                let Elements = [<polygon
                    points={this.mapCoordsToSvgFormat(scaledCoords)}
                    fillOpacity = {0.5}
                    {...props}
                />
                ]
                if (!ishover || type !== 'result_tracking_room') {
                    Elements.push(<text
                        x={scaledRectCoords[0] + (scaledRectCoords[2] - scaledRectCoords[0]) / 2}
                        y={scaledRectCoords[1] + (scaledRectCoords[3] - scaledRectCoords[1]) / 2}
                        dominantBaseline="middle"
                        textAnchor="middle"
                        style={roomAndPolyStyle}
                        className = {text}
                    >
                        {text}
                    </text>)
                    if(ishover){
                        document.getElementById("prefill-layer").getElementsByClassName(text)[0].style.fillOpacity= "0"
                        }
                    else if(document.getElementById("prefill-layer") && !ishover && document.getElementById("prefill-layer").getElementsByClassName(text)[0]) {
                        document.getElementById("prefill-layer").getElementsByClassName(text)[0].style.fillOpacity = "1"
                    }
                    
                }
                if (ishover && type === 'result_tracking_room') {
                    Elements.push(<text
                        x={scaledRectCoords[0] + (scaledRectCoords[2] - scaledRectCoords[0]) / 2}
                        y={scaledRectCoords[1] + (scaledRectCoords[3] - scaledRectCoords[1]) / 2}
                        dominantBaseline="middle"
                        textAnchor="middle"
                        className = {text}
                        style={roomAndPolyStyle}
                    >
                        {text}
                    </text>)
                     if(ishover){
                        document.getElementById("prefill-layer").getElementsByClassName(text)[0].style.fillOpacity= "0"
                        }
                }
                if (ishover && type === "sample_floor_room") {
                    let sample_elements = this.drawSampleMapping(area.sample_areas)
                    Elements.push(...sample_elements)
                    Elements.push(
                        <circle
                            cx={right - imageRadius - margin}
                            cy={top + imageRadius + margin}
                            r={imageRadius}
                            fill="white"
                            strokeColor="white"
                        />
                    )
                    Elements.push(
                        < image 
                        href={expandIcon} 
                        x={right - imgWidthHeigth - margin - imageRadius / 2} 
                        y={top + imageRadius / 2 + margin} 
                        height={imgWidthHeigth} 
                        width={imgWidthHeigth} 
                        />
                    )
                }
                if (ishover && type === "result_display_room") {
                    let sample_elements = this.drawSampleMapping(area.sample_areas)
                    Elements.push(...sample_elements)
                }
                return (Elements);
            default:
                return (
                    <polygon
                        points={this.mapCoordsToSvgFormat(scaledCoords)}
                        {...props}
                    />
                );
        }
    }

    renderCurrentlyHoveredSvgElement() {
        const area = this.state.currentlyHoveredArea;
        if (!(area)) return null;
        return this.getMatchingSvgElementForShape(area.shape, area.coords, {
            key: area._id || 'hover-area',
            fill: area.fillColor || 'transparent',
            stroke: area.shape==='room' || area.shape === 'poly' ? '#0ff7f3':area.strokeColor || this.props.strokeColor,
            strokeWidth: '2',
        }, true, area.type, area.text, area);
    }

    renderCurrentlyClickedSvgElement() {
        const area = this.props.currentlyClickedArea;
        if (!(area)) return null;
        return this.getMatchingSvgElementForShape(area.shape, area.coords, {
            key: area._id || 'click-area',
            fill: area.clickedFillColor || 'transparent',
            stroke: area.shape==='room' || area.shape === 'poly' ? '#0ff7f3': area.clickedStrokeColor || this.props.strokeColor,
            strokeWidth: '2',
        }, true, area.type, area.text, area);
    }

    renderPrefillSvgElements() {
        return this.props.map.areas.map((area, index) => {
            if (!area.preFillColor) return null;
            const uniqueKey = area.name || area._id || `area-${index}`;
            const element = this.getMatchingSvgElementForShape(area.shape, area.coords, {
                key: uniqueKey,
                fill: area.preFillColor || 'transparent',
                stroke: area.strokeColor || this.props.strokeColor,
                strokeWidth: area.lineWidth || this.props.lineWidth,
            }, false, area.type, area.text, area);
            
            // If element is null (invalid dimensions), skip it
            if (!element) return null;
            
            // If element is an array (like room with multiple elements), ensure all have keys
            if (Array.isArray(element)) {
                return element.map((el, idx) => {
                    if (React.isValidElement(el) && !el.key) {
                        return React.cloneElement(el, { key: `${uniqueKey}-${idx}` });
                    }
                    return el;
                });
            }
            
            // If single element, ensure it has a key
            if (React.isValidElement(element) && !element.key) {
                return React.cloneElement(element, { key: uniqueKey });
            }
            
            return element;
        }).filter(Boolean).flat(); // Remove null elements and flatten arrays
    }

    renderAreas() {
        return this.getExtendedAreas().map((extendedArea, index) => {
            return (
                <area
                    key={extendedArea._id || index}
                    shape={extendedArea.shape}
                    coords={extendedArea.scaledCoords.join(',')}
                    onMouseEnter={this.hoverOn.bind(this, extendedArea, index)}
                    onMouseLeave={this.hoverOff.bind(this, extendedArea, index)}
                    onMouseMove={this.mouseMove.bind(this, extendedArea, index)}
                    onMouseDown={this.mouseDown.bind(this, extendedArea, index)}
                    onMouseUp={this.mouseUp.bind(this, extendedArea, index)}
                    onClick={this.click.bind(this, extendedArea, index)}
                    href={extendedArea.href}
                    alt={extendedArea.shape}
                />
            );
        });
    }

    renderChildren() {
        if (this.props.renderChildren) {
            return this.props.renderChildren();
        }
        return null;
    };

    render() {
        const ImageElement = React.forwardRef((props, ref) => (
            <img
                style={this.styles.img}
                src={this.props.src}
                useMap={`#${this.props.map.name}`}
                alt=""
                ref={ref}
                onLoad={this.initCanvases}
                onClick={this.imageClick.bind(this)}
                onMouseMove={(event) => this.imageMouseMove(event)}
                onMouseDown={this.imageMouseDown.bind(this)}
                onMouseUp={this.imageMouseUp.bind(this)}
                onMouseEnter={(event) => this.imageMouseEnter(event)}
                onMouseLeave={() => {
                    this.setState({ showMagnifier: false });
                }}
            >
            </img>
        ));

        return (
            <div style={this.styles.container} ref={node => (this.container = node)}>
                <ImageElement ref={this.imgRef} />
                <svg id="prefill-layer" ref={node => (this.prefillSvg = node)} style={this.styles.prefillCanvas}>
                    {this.renderPrefillSvgElements()}
                </svg>
                <svg id="hover-layer" ref={node => (this.hoverSvg = node)} style={this.styles.hoverCanvas}>
                    {this.state && this.state.currentlyHoveredArea && this.renderCurrentlyHoveredSvgElement()}
                </svg>
                <svg id="click-layer" ref={node => (this.clickSvg = node)} style={this.styles.clickCanvas}>
                    {this.state && this.props.currentlyClickedArea && this.renderCurrentlyClickedSvgElement()}
                </svg>
                <map name={this.props.map.name} style={this.styles.map}>
                    {this.renderAreas()}
                </map>
                {this.renderChildren()}
            </div>
        );
    }
}

ImageMapper.defaultProps = {
    active: true,
    fillColor: 'rgba(255, 255, 255, 0.5)',
    lineWidth: 1,
    map: {
        areas: [],
        name: 'image-map-' + Math.random()
    },
    strokeColor: 'rgba(0, 0, 0, 0.5)',
    imgRef: undefined,
};